import { createTheme } from '@mui/material';
import { defaultTheme } from './default-theme';
var darkTheme = createTheme(defaultTheme);
export { darkTheme };